<template>
    <div>
        <div class="card-item">
            <div class="card-title">
                <span>主体证书/资质信息</span>
            </div>
            <div class="card-content">
                <div class="card-content-search">
                    <el-input size="small" class="card-content-search-input" v-model="inputValue" clearable
                              placeholder="请输入"></el-input>
                    <button class="card-content-search-btn" @click="serachData()">搜索</button>
                </div>
                <div class="card-content-table">
                    <el-table
                            border
                            :data="tableList"
                            align="center"
                            style="width: 100%"
                            ref="table"
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',}"
                            :row-key="getRowKeys"
                            :expand-row-keys="expands">
                        <el-table-column
                                label="序号"
                                type="index"
                                align="center"
                                width="50">
                            <template scope="scope">
                                <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书类别"
                                align="center"
                                prop="qualificationTypeName">
                            <template scope="scope">
                                <p>{{scope.row.qualificationTypeName || "--"}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书编号"
                                align="center"
                                prop="certNo">
                            <template scope="scope">
                                <p>{{scope.row.certNo || "--"}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书名称"
                                align="center"
                                prop="certName">
                            <template scope="scope">
                                <p>{{scope.row.certName || "--"}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="证书有效期至"
                                align="center"
                                prop="qualificationValidityEnd">
                            <template scope="scope">
                                <p>{{scope.row.qualificationValidityEnd | dateStrIntercept}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="资质名称"
                                align="center"
                                prop="qualificationName"
                                width="272">
                            <template scope="scope">
                                <p>{{scope.row.qualificationName || '--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="数据来源"
                                align="center"
                                prop="comeFrom">
                        </el-table-column>
                        <el-table-column
                                label="数据状态"
                                align="center"
                                prop="state">
                            <template scope="scope">
                                <p type="text" v-if="scope.row.state == 1" class="change-examine"><i class="examine-effective"></i><span>有效</span></p>
                                <p type="text" v-else-if="scope.row.state == 2" class="change-examine"><i class="examine-waitSubmit"></i><span>待生效</span></p>
                                <p type="text" v-else-if="scope.row.state == 3" class="change-examine"><i class="examine-invalid"></i><span>已作废</span></p>
                                <p type="text" v-else-if="scope.row.state == 4" class="change-examine"><i class="examine-waitSubmit"></i><span>待提交</span></p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="登记日期"
                                align="center"
                                prop="createTime">
                            <template scope="scope">
                                <p>{{scope.row.createTime | dateStrIntercept}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="作废日期"
                                align="center"
                                prop="cancelTime">
                            <template scope="scope">
                                <p>{{scope.row.cancelTime && scope.row.cancelTime.substring(0,11)}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="toogleExpand(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand" width="1">
                            <template slot-scope="props">
                                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" style="position: relative" inline>
                                    <el-row>
                                        <el-col :span="8">
                                            <el-form-item label="资质证书上传 : " prop="certFilePath">
                                                <imgUploadView v-if="props.row.certFilePath" :ruleForm.sync="ruleForm" :backgroundType="5" :imgUrl.sync="props.row.certFilePath"/>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="16">
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="证书类别 : " prop="qualificationType" size="small">
                                                        <span>{{props.row.qualificationTypeName}}</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="证书编号 : " prop="certNo" size="small">
                                                        <span>{{props.row.certNo}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="证书名称 : " prop="certName" size="small">
                                                        <span>{{props.row.certName}}</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="发证机关 : " prop="licenceOrg" size="small">
                                                        <span>{{props.row.licenceOrg}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item label="发证日期 : " prop="sendTime" size="small">
                                                        <span>{{props.row.sendTime | dateStrIntercept}}</span>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="证书有效期限至 : " prop="qualificationValidityEnd" size="small">
                                                        <span>{{props.row.qualificationValidityEnd | dateStrIntercept}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="ruleForm.qualificationType == 'A03' || props.row.qualificationType == 'A03'">
                                                <el-col>
                                                    <el-form-item label="资质类别及等级 : " prop="entQualificationCertLevels">
                                                        <qualificationAdd
                                                                :state="props.row.state"
                                                                :entQualificationCertLevels.sync="props.row.entQualificationCertLevels"
                                                                style="width: 814px;margin-top: 12px"
                                                        >
                                                        </qualificationAdd>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row v-if="ruleForm.qualificationType == 'A02' || props.row.qualificationType == 'A02'">
                                                <el-col>
                                                    <el-form-item label="许可范围 : " prop="remark" size="small">
                                                        <span>{{props.row.remark}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <span @click="toogleExpand(props.row)"
                                      style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;">
                                    收起<i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="total, prev, pager, next"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import dataDictionary from "../../../store/modules/dataDictionary";
    export default {
        name: "main-qualifications-form",
        data() {
            return {
                id:'',
                dataId:'',
                changeData:{},
                getRowKeys(row) {
                    return row.id
                },
                // 要展开的行，数值的元素是row的key值
                expands: [],
                inputValue: '',
                ruleForm: {
                    certFilePath: '',
                    qualificationType: '',
                    certNo: '',
                    certName: '',
                    licenceOrg: '',
                    sendTime: '',
                    qualificationValidityEnd: '',
                    remark: '',
                    entQualificationCertLevels:[],
                },
                currentPage:1,
                pageSize:10,
                total:0,
                rules:{
                    certFilePath: [
                        {required: true, message: '请上传文件扫描', trigger: 'change'},
                    ],
                    qualificationType: [
                        {required: true, message: '请选择证书类别', trigger: 'change'},
                    ],
                    certNo: [
                        {required: true, message: '请输入证书编号', trigger: 'blur'},
                    ],
                    certName: [
                        {required: true, message: '请输入证书名称', trigger: 'blur'},
                    ],
                    licenceOrg: [
                        {required: true, message: '请输入发证机关', trigger: 'blur'},
                    ],
                    sendTime: [
                        {required: true, message: '请选择发证日期', trigger: 'change'},
                    ],
                    qualificationValidityEnd: [
                        {required: true, message: '请选择证书有效期限至', trigger: 'change'},
                    ],
                    remark: [
                        {required: true, message: '请输入许可范围', trigger: 'blur'},
                    ],
                    entQualificationCertLevels: [
                        {required: true, message: '请选择资质类别及等级', trigger: 'change'},
                    ]
                },
                tableList:[],
                queryParameter:{
                    attachmentParamList:[], // 附件列表
                    entQualificationCertLevels:[], // 类别等级列表
                    id:'', // id
                    entId:'', // 企业ID
                    entRoleCode:'', // 企业用户角色Code
                    certNo:'', // 证书编号
                    licenceOrg:'', // 发证机关
                    qualificationType:'', // 证书类别code
                    qualificationIndustry:'', // 资质行业code
                    qualificationSerial:'', // 资质序列coode
                    qualificationProfessional:'', // 资质专业code
                    qualificationLevel:'', // 资质等级code
                    qualificationState:'', // 证书状态
                    entPrincipal:'', // 企业负责人
                    technicalDirector:'', // 技术负责人
                    entPrincipalJob:'', // 企业负责人职务
                    technicalDirectorJob:'', // 技术负责人职务
                    entPrincipalTitle:'', // 企业负责人职称Code
                    technicalDirectorTitle:'', // 技术负责人职称Code
                    qualificationValidityStart:'', // 开始资质有效期
                    qualificationValidityEnd:'', // 结束资质有效期
                    businessScope:'', // 可承担业务
                    state:'', // 状态
                    sendTime:'', // 核发日期
                    sendOrg:'', // 核发机关
                    remark:'', // 备注
                    delFlag:'', // 是否删除
                    createUser:'', // 创建者
                    createTime:'', // 创建时间
                    updateUser:'', // 修改者
                    updateTime:'', // 修改时间
                    cancelFlag:'', // 是否作废
                    cancelTime:'', // 作废时间
                    qualificationName:'', // 资质名称
                    certName:'', // 证书名称
                    comeFrom:'', // 数据来源
                    certFilePath:''
                }
            }
        },
        computed:{
            ...mapState({
                qualificationTypeList: (state) => state.dataDictionary.qualificationTypeList,
            })
        },
        created() {
            this.getRouterQuery();
            this.getChangeInfo();
            this.querData();
            this.$store.dispatch('dataDictionary/getQualificationTypeList');//获取证书类别
        },
        activated() {
            this.getRouterQuery();
            this.getChangeInfo();
            this.querData();
            this.$store.dispatch('dataDictionary/getQualificationTypeList');//获取证书类别
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                for (let i in this.changeData){
                    if(row.id == i && this.changeData[i] == 1){
                        return 'newData-row';
                    }else if(row.id == i && this.changeData[i] == 2){
                        return 'cancel-row';
                    }else {
                        return ''
                    }
                }
            },
            getChangeInfo(){
                this.$http.get(`/change/field-record/module-item?changeRecordId=${this.dataId}&changeModule=qualificationCert`).then((res)=>{
                    if(res.data.data && res.data.data.length>0){
                        this.changeData =res.data.data[0].changeFields
                    }
                })
            },
            getRouterQuery(){
                this.id = this.$route.params.changeId;
                this.dataId = this.$route.params.id;
            },
            // 获取数据
            querData(){
                this.$http.post('/change/hentqualificationcert/list',{
                    page:this.currentPage,
                    rows:this.pageSize,
                    filter:{
                        entId:this.id
                    },
                    searchKey: this.inputValue,
                    orderBy:'create_time desc'
                }).then((res)=>{
                    if(res.data){
                        this.tableList = res.data.rows;
                        this.currentPage = res.data.pageIndex;
                        this.pageSize = res.data.pageSize;
                        this.total = res.data.total;
                        if(this.tableList.length>0 && this.tableList[0].state == 4){
                            this.expands.push(this.tableList[0].id)
                        }
                    }
                })
            },
            // 搜索
            serachData() {
                this.currentPage = 1;
                this.querData();
            },
            // 新增
            saveData() {
                for(let key in this.queryParameter){
                    if(key == 'attachmentParamList'){
                        this.queryParameter[key] = []
                    }else if(key == 'entQualificationCertLevels'){
                        this.queryParameter[key] = []
                    }else{
                        this.queryParameter[key] = ''
                    }
                }
                if(this.tableList.length>0 && this.tableList[0].state == 4){
                    return
                }else{
                    this.queryParameter.entId=this.id;
                    this.queryParameter.state=4;
                    this.$http.post('/change/hentqualificationcert/save',this.queryParameter).then((res)=>{
                    });
                    this.querData();
                }
            },
            // 删除/取消
            deleteData(row,formName) {
                this.$http.post('/change/hentqualificationcert/delete?id='+row.id).then((res)=>{
                });
                this.querData();
                this.$refs[formName].resetFields();
            },
            // 查看
            toogleExpand(row) {
                this.$refs.table.toggleRowExpansion(row)
            },
            // 作废
            voidData(row) {
                this.$http.post('/change/hentqualificationcert/cancel?id='+row.id).then((res)=>{
                });
                this.querData();
            },
            // 保存
            preservation(row,formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.queryParameter.entId= this.id;
                        this.queryParameter.state= row.state;
                        this.queryParameter.id= row.id;
                        this.queryParameter.qualificationType= this.ruleForm.qualificationType;
                        this.queryParameter.certNo= this.ruleForm.certNo;
                        this.queryParameter.certName= this.ruleForm.certName;
                        this.queryParameter.licenceOrg= this.ruleForm.licenceOrg;
                        this.queryParameter.sendTime= this.ruleForm.sendTime;
                        this.queryParameter.qualificationValidityEnd= this.ruleForm.qualificationValidityEnd;
                        this.queryParameter.remark= this.ruleForm.remark;
                        this.queryParameter.entQualificationCertLevels = this.ruleForm.entQualificationCertLevels;
                        this.queryParameter.certFilePath = this.ruleForm.certFilePath;
                        this.$http.post('/change/hentqualificationcert/save',this.queryParameter).then((res)=>{});
                        this.querData();
                        this.$refs[formName].resetFields();
                    } else {
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            }
        },
        filters:{
            dateStrIntercept(str){
                if(str){
                    return str.substring(0,11);
                }else{
                    return '--'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-textarea__inner {
        width: 750px;
        height: 80px;
    }
    .bottom-btn {
        display: flex;
        justify-content: center;

        .el-button {
            width: 96px;
            height: 40px;
            margin: 20px 24px 20px 0;
        }
    }

    .card-content {
        .card-content-search {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            padding-top: 4px;
            margin-right: 12px;

            .card-content-search-input {
                width: 250px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 2px;
                outline: none;
            }

            .card-content-search-btn {
                width: 70px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 32px;
                cursor: pointer;
            }

            .card-content-search-add {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
            }
            .card-content-search-add-able {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
                opacity: 25%;
            }
        }

        .card-content-table {
            margin: 16px 12px 0 12px;
            /deep/ .el-input__inner {
                width: 324px;
            }
        }
    }
</style>